<div mat-dialog-title class="justify-content-center align-items-center" style="margin-top: -10px !important;">
    <mat-icon *ngIf="data.success" style="color: green; font-size: 40px; height: 40px; width: 40px;" class="mr-3">done</mat-icon> 
    <mat-icon *ngIf="data.error" style="color: red; font-size: 40px; height: 40px; width: 40px;" class="mr-3">close</mat-icon>
    <span> {{data.message}} </span>
    
</div>
<div mat-dialog-content>


</div>
<div mat-dialog-actions align="center">
    <button mat-button mat-dialog-close>Cerrar</button>
</div>